import React from 'react';
import PropTypes from 'prop-types';
import MenuClose from '../../../icons/menu-close.svg';
import MenuHamburger from '../../../icons/menu-hamburger.svg';

import './HamburgerButton.module.scss';

class HamburgerButton extends React.PureComponent {
  render() {
    const {
      active,
      onClick,
      color,
      hoverColor,
    } = this.props;

    const Icon = active ? MenuClose : MenuHamburger;

    return (
      <button styleName="button" onClick={onClick}>
        <Icon
          styleName="icon"
          style={{
            '--color': color,
            '--hover-color': hoverColor,
          }}
        />
      </button>
    );
  }
}

HamburgerButton.defaultProps = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
};

export default HamburgerButton;


// WEBPACK FOOTER //
// ./src/js/widgets/Header/HamburgerButton.js